import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ParamsService } from '../../pages/params/params.service';

@Component({
  selector: 'app-message',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss']
})
export class MessageModalComponent {
  type: number = 1;
  messageForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MessageModalComponent>,
    private paramsService: ParamsService
  ) {    
    this.type = this.data?.type || 1;
    this.messageForm = this.fb.group({
      text: [this.data.message?.text || '', Validators.required],
      messageType: [this.data.message?.messageType || this.type, Validators.required],
      displayUntil: [this.formatDate(this.data.message?.displayUntil) || null],
      isDisplayed: [this.data.message ? this.data.message?.isDisplayed : true, Validators.required]
    });
  }
  
  resetDisplayUntilDate(): void {
    this.messageForm.get('displayUntil')?.reset();
  }

  onSubmit(): void {
    if (this.messageForm.valid) {
      if (this.data.message) {
        this.paramsService.editMessage(this.data.message._id, this.messageForm.value).subscribe((res) => {
          this.dialogRef.close(res);
        });
      } else {
        this.paramsService.addMessage(this.messageForm.value).subscribe((res) => {
          this.dialogRef.close(res);
        });
      }
    }
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
}
